import { ThemeMode } from "@core/context/theme-context";

// src/core/theme/client-theme.ts
export const getClientTheme = (): ThemeMode => {
  if (typeof window !== "undefined") {
    const initialTheme = window.__INITIAL_THEME__;
    if (initialTheme) {
      return initialTheme;
    }

    const cookie = document.cookie.match(/theme=(light|dark)/);
    return cookie ? (cookie[1] as ThemeMode) : "light";
  }
  return "light";
};
